Ext.define('SA.VectorMapInsetMap', {
    alias: 'widget.vector-map-inset-map',
    extend: 'Ext.Component',

    childEls: ['container', 'extentRectangle'],
    cls: 'sa-vector-map-inset-map',

    renderTpl: [
        '<div id="{id}-container" class="sa-vector-map-inset-map-container"></div>',
        '<div id="{id}-extentRectangle" class="sa-vector-map-inset-map-extent-rectangle"></div>'
    ],

    afterRender() {
        var {maxExtent, style} = this;

        this.callParent();

        this.map = new maplibregl.Map({
            boxZoom: false,
            container: this.container.dom,
            doubleClickZoom: false,
            dragRotate: false,
            keyboard: false,
            maxBounds: maxExtent.toLngLatBounds(),
            minZoom: 0,
            scrollZoom: false,
            style,
            touchPitch: false,
            touchZoomRotate: false,
            trackResize: false
        });
    },

    destroy() {
        this.map?.remove();

        this.callParent();
    },

    getCenter() {
        return SA.VectorMapCoordinate.fromLngLat(this.map.getCenter().toArray());
    },

    onMove(callback, scope) {
        this.map.on('move', ({suppressMoveEvents}) => {
            if (!suppressMoveEvents) {
                callback.call(scope);
            }
        });
    },

    onMoveEnd(callback, scope) {
        this.map.on('moveend', ({suppressMoveEvents}) => {
            if (!suppressMoveEvents) {
                callback.call(scope);
            }
        });
    },

    onWebGLContextLost(callback, scope) {
        this.map.on('webglcontextlost', () => {
            if (!this.isDestroyed) {
                callback.call(scope);
            }
        });
    },

    refreshExtentRectangle(extent) {
        var {x: left, y: bottom} = this.map.project(extent.getSouthWest().toLngLat()),
            {x: right, y: top} = this.map.project(extent.getNorthEast().toLngLat());

        this.extentRectangle.setStyle({
            left: `${left}px`,
            top: `${top}px`,
            width: `${right - left}px`,
            height: `${bottom - top}px`
        });
    },

    setExtentAndZoom(extent, zoom, {suppressMoveEvents}) {
        this.map.jumpTo({center: extent.getCenter().toLngLat(), zoom}, {suppressMoveEvents});

        this.refreshExtentRectangle(extent);
    }
});